import { Injectable } from '@angular/core';
import { version } from '../../../../assets/version/version.json';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  constructor() {}

  getVersion(): string {
    return version;
  }
}
